import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function Connexion() {
  const [nom_club, setNomClub] = useState('');
  const [password_club, setPasswordClub] = useState('');
  const [error, setError] = useState(null); // État pour les messages d'erreur
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null); // Réinitialiser l'erreur à chaque soumission
  
    try {
      const response = await axios.post('https://www.clublfit.org/api/login', {
        nom_club,
        password_club,
      });
      const { token } = response.data;
  
      // Enregistrer le jeton dans le stockage local après la réussite de la connexion
      localStorage.setItem('token', token);
  
      // Émettre l'événement "loggedIn" après la connexion pour rafraîchir le header
      window.dispatchEvent(new Event('loggedIn'));
  
      // Rediriger vers la page d'accueil
      navigate('/');
    } catch (error) {
      console.error('Erreur de connexion:', error.response?.data || error);
      setError(error.response?.data.message || 'Erreur de connexion'); // Afficher le message d'erreur
    }
  };
  

  return (
    <div className="container">
      <h2>Connexion</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="nomClub">Nom du Club</label>
          <input
            type="text"
            className="form-control"
            id="nomClub"
            value={nom_club}
            onChange={(e) => setNomClub(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="passwordClub">Mot de Passe</label>
          <input
            type="password"
            className="form-control"
            id="passwordClub"
            value={password_club}
            onChange={(e) => setPasswordClub(e.target.value)}
            required
          />
        </div>
        {error && <p className="text-danger">{error}</p>} {/* Afficher le message d'erreur */}
        <button type="submit" className="btn btn-primary">Se Connecter</button>
      </form>
    </div>
  );
}

export default Connexion;
